module.exports = __webpack_public_path__ + "img/12.0a13d8b4.png";